import {useSelector} from 'react-redux'
import {RootState} from '../store'

export const useCurrency = () => {
  const currencyRate = useSelector((state: RootState) => state.currency.rate)
  const currency = useSelector((state: RootState) => state.currency.currency)
  const currencySymbol = useSelector((state: RootState) => state.currency.symbol)

  const formatAmount = (value: number) =>
      new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value * currencyRate)

  const formatAmountWithoutCurrency = (value: number) =>
      new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)

  const convertFromUSD = (usd: number) => usd * currencyRate
  const convertToUSD = (amountInCurrency: number) => amountInCurrency / currencyRate

  return {
    formatAmount,
    formatAmountWithoutCurrency,
    convertFromUSD,
    convertToUSD,
    currency,
    currencySymbol,
  }
}
